import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9c5cc4d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "device-list-page" }
const _hoisted_2 = { class: "ws_common_operation ws_pr20" }
const _hoisted_3 = { class: "data ws_ml20 ws_mr20" }
const _hoisted_4 = { class: "table" }

import { onMounted, ref, watch, computed } from 'vue'
import AdvancedQueryLayout from '@/components/advanced-query-layout'
import {
  PAGE_SIZES,
  DEVICE_STATUS_ENUM,
  CODE_ENUM,
  CONNECT_TYPE,
} from '@/common'
import { useRouter } from 'vue-router'
import { queryTenantDeviceList } from '@/api'
import { ElMessageBox } from 'element-plus'
import SelectDevice from '@/components/select-device'
import OperationButtonList from '@/components/operation-button-list'
import { msgbox } from '@/utils'
import { useProductStore } from '@/stores/product'
import { useTenantStore } from '@/stores/tenant'
import moment from 'moment'
import { ElMessage } from 'element-plus'
import BatchForm from './batch-active-form.vue'
import { useRoute } from 'vue-router'



export default /*#__PURE__*/_defineComponent({
  __name: 'device-list',
  setup(__props) {

const $route = useRoute()

const orgId = $route.query.orgId

const getTime = (time: any) => {
  return time ? moment(time).format('YYYY-MM-DD HH:mm:ss') : '-'
}

const isEndTime = (time: any) => {
  const nowTime = moment().valueOf()
  return nowTime > time
}

const deviceStatusOps = [
  {
    label: '未激活',
    value: DEVICE_STATUS_ENUM.NOACTIVATE,
  },
  {
    label: '已激活',
    value: DEVICE_STATUS_ENUM.INACTIVATE,
  },
]

const productStrore = useProductStore()
productStrore.queryGetewayType()

const tenantStore = useTenantStore()

const getButtonList = (row: any) => {
  return [
    {
      type: 'detail',
      text: '详情',
      onClick: () => {
        router.push({
          name: 'device-data',
          query: {
            deviceId: row.deviceId,
          },
        })
      },
    },
  ]
}

const advancedRef = ref()

const router = useRouter()

const tableData: any = ref([])
const formInline = ref({
  keyWords: '',
  deviceId: undefined,
  deviceSn: '',
  productKey: '',
  deviceActiveStatus: '',
  deviceNo: '',
})

const deviceStatusMap = {
  [DEVICE_STATUS_ENUM.ONLINE]: 'success',
  [DEVICE_STATUS_ENUM.INACTIVATE]: '',
  [DEVICE_STATUS_ENUM.OFFLINE]: 'info',
  [DEVICE_STATUS_ENUM.NOACTIVATE]: 'warning',
}
const getDeviceTagType = (status: any) => {
  return deviceStatusMap[status]
}

onMounted(async () => {
  fetchList()
})

const pageParams = ref({
  curPage: 1,
  pageSize: 10,
})
const total = ref(0)

const handleSizeChange = () => {
  pageParams.value.curPage = 1
  fetchList()
}
const handleCurrentChange = () => {
  fetchList()
}

const col: any = [
  {
    prop: 'deviceName',
    label: '设备名称',
  },
  {
    prop: 'deviceSn',
    label: '设备SN',
  },
  {
    prop: 'imei',
    label: 'IMEI',
  },
  {
    prop: 'productTypeValue',
    label: '所属产品',
  },
  {
    prop: 'datagramNum',
    label: '回传报文条数',
    sortable: 'custom',
  },
  {
    prop: 'productTypeValue',
    label: '激活时间',
    sortable: 'custom',
    formatter: ({ time }: any) => {
      return getTime(time)
    },
  },
  // {
  //   prop: 'productTypeValue',
  //   label: '激活到期时间',
  //   sortable:'custom'
  // },
]

const tableLoading = ref(false)

const fetchList = async (queryData?: any) => {
  const keepAliveData = advancedRef.value.getKeepAliveData() || {}
  const { data, reset } = queryData || {}
  if (typeof reset === 'boolean') {
    pageParams.value.curPage = 1
  }
  tableLoading.value = true
  const res: any = await queryTenantDeviceList({
    ...pageParams.value,
    ...data,
    ...keepAliveData,
    orgId,
  }).finally(() => {
    tableLoading.value = false
  })
  if (res?.code === 0) {
    tableData.value = res?.data?.records || []
    total.value = res?.data?.total || 0
  }
}

const multipleSelection: any = ref([])
const handleSelectionChange = (val: any) => {
  multipleSelection.value = val
}

const batchDeviceConf = ref({
  visible: false,
})
const handleBatchDeviceConf = () => {
  const isAllSg = !multipleSelection.value.some((item: any) => {
    return !item.sgFlag
  })
  if (!isAllSg) {
    ElMessage.warning('请选星地一体机终端')
    return
  }

  const isAllNoactive = !multipleSelection.value.some((item: any) => {
    return item.deviceActiveStatus !== DEVICE_STATUS_ENUM.NOACTIVATE
  })
  if (!isAllNoactive) {
    ElMessage.warning('请选择未激活的设备')
    return
  }
  batchDeviceConf.value = {
    visible: true,
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(AdvancedQueryLayout), {
        class: "advance-container",
        ref_key: "advancedRef",
        ref: advancedRef,
        model: formInline.value,
        onFetchList: fetchList,
        "label-width": 112
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "设备名称",
            prop: "deviceId"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(SelectDevice), {
                modelValue: formInline.value.deviceId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formInline.value.deviceId) = $event)),
                orgId: _unref(orgId)
              }, null, 8, ["modelValue", "orgId"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "设备SN",
            prop: "deviceSn"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formInline.value.deviceSn,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formInline.value.deviceSn) = $event)),
                clearable: "",
                maxlength: "50",
                class: "ws_select"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "所属产品",
            prop: "productKey"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: formInline.value.productKey,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formInline.value.productKey) = $event)),
                clearable: "",
                class: "ws_select"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(productStrore).productGetewayType, (item) => {
                    return (_openBlock(), _createBlock(_component_el_option, {
                      key: item.code,
                      label: item.name,
                      value: item.code
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "状态",
            prop: "deviceActiveStatus"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_select, {
                modelValue: formInline.value.deviceActiveStatus,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formInline.value.deviceActiveStatus) = $event)),
                clearable: "",
                class: "ws_select"
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(deviceStatusOps, (item) => {
                    return _createVNode(_component_el_option, {
                      key: item.value,
                      label: item.label,
                      value: item.value
                    }, null, 8, ["label", "value"])
                  }), 64))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_button, {
          plain: "",
          disabled: multipleSelection.value.length === 0,
          onClick: handleBatchDeviceConf
        }, {
          default: _withCtx(() => [
            _createTextVNode("批量激活")
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives((_openBlock(), _createBlock(_component_el_table, {
            class: "ws_common_table ws_mt20",
            data: tableData.value,
            onSelectionChange: handleSelectionChange
          }, {
            empty: _withCtx(() => [
              _createVNode(_component_el_empty, { description: "暂无数据" })
            ]),
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                type: "selection",
                width: "55"
              }),
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(col, (item, index) => {
                return _createVNode(_component_el_table_column, _mergeProps({ key: index }, {
              ...item,
            }, { "show-overflow-tooltip": "" }), null, 16)
              }), 64)),
              _createVNode(_component_el_table_column, {
                label: "激活到期时间",
                width: "190",
                sortable: "custom",
                prop: "activeEndTime"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("span", {
                    class: _normalizeClass({ 'red-text': isEndTime(scope.row.activeEndTime) })
                  }, _toDisplayString(getTime(scope.row.activeEndTime)), 3)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                width: "150",
                prop: "deviceActiveStatusValue",
                label: "设备状态"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_tag, {
                    class: "ml-2",
                    type: getDeviceTagType(scope.row.deviceActiveStatus)
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(scope.row.deviceActiveStatusValue), 1)
                    ]),
                    _: 2
                  }, 1032, ["type"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                width: 300,
                label: "操作"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_unref(OperationButtonList), {
                    scope: scope.row,
                    buttonList: getButtonList(scope.row)
                  }, null, 8, ["scope", "buttonList"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"])), [
            [_directive_loading, tableLoading.value]
          ]),
          _createVNode(_component_el_pagination, {
            class: "ws_mt50",
            "current-page": pageParams.value.curPage,
            "onUpdate:currentPage": _cache[4] || (_cache[4] = ($event: any) => ((pageParams.value.curPage) = $event)),
            "page-size": pageParams.value.pageSize,
            "onUpdate:pageSize": _cache[5] || (_cache[5] = ($event: any) => ((pageParams.value.pageSize) = $event)),
            "page-sizes": _unref(PAGE_SIZES),
            layout: "->, total, sizes, prev, pager, next, jumper ",
            total: total.value,
            onSizeChange: handleSizeChange,
            onCurrentChange: handleCurrentChange
          }, null, 8, ["current-page", "page-size", "page-sizes", "total"])
        ])
      ])
    ]),
    _createVNode(BatchForm, {
      visible: batchDeviceConf.value.visible,
      "onUpdate:visible": _cache[6] || (_cache[6] = ($event: any) => ((batchDeviceConf.value.visible) = $event)),
      data: multipleSelection.value,
      onSuccess: fetchList
    }, null, 8, ["visible", "data"])
  ], 64))
}
}

})